import React, { useState, useEffect } from "react";
import { MediumButtonStyle } from "./ButtonStyle";
import mathService from "../services/math.service";
import "../components/Style/cart.css";
import cartImage from "../assets/slider4.jpg";
import secure from "../assets/support/security.png";
import helpcenter from "../assets/support/helpcenter.png";
import faq from "../assets/support/faq.png";

const uap_images = [
  { icon: secure, title: "Secure Payment" },
  { icon: helpcenter, title: "Help Center" },
  { icon: faq, title: "FAQ" },
];

export const CartDesktopSection = ({
  cart = [],
  proceedToCheckout,
  updateCart,
  removeFromCart,
}) => {
  const [localCart, setLocalCart] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    setLocalCart(cart || []);
  }, [cart]);

  const handleCheckboxChange = (itemId) => {
    setCheckedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const checkedCart = (cart || []).filter((item) => checkedItems[item.id]) || [];

  const mrp = mathService.totalCartAmount(checkedCart).totalMRP;
  const totalSellingAmount =
    mathService.totalCartAmount(checkedCart).totalSellingAmount;
  const discountAmount =
    mathService.discountRate(mrp, totalSellingAmount).offPrice;

  const handleQuantityChange = (cartId, newQuantity) => {
    if (newQuantity >= 1 && newQuantity <= 5) {
      const updatedCart = localCart.map((item) =>
        item.id === cartId ? { ...item, quantity: newQuantity } : item
      );
      setLocalCart(updatedCart);
      updateCart(cartId, newQuantity);
    }
  };

  const applyCoupon = () => {
    console.log("Applying coupon:", couponCode);
  };

  const CartTable = () => (
    <div className="cart-table">
      <h2 style={{ fontSize: 24, fontWeight: "bold", color: "black", padding: "10px", marginTop: 0, marginBottom: "20px" }}>
        Your Cart
      </h2>
  
      <div style={{
        backgroundColor: "#ffffff",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        padding: 20,
        margin: 20,
        maxWidth: 800,
        width: "100%",
      }}>
        <h2 style={{ fontSize: 18, fontWeight: "bold", color: "#333", marginBottom: 20 }}>
          Total Items in Cart: ({(cart || []).length || 0})
        </h2>
  
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {(cart || []).length === 0 ? (
            <div style={{
              padding: "1rem",
              background: "#f4f6fb",
              borderRadius: "10px",
              textAlign: "center",
              fontSize: "1rem",
              fontWeight: "500",
              color: "#666",
            }}>
              Your cart is empty
            </div>
          ) : (
            (cart || []).map((item, key) => {
              const imageURL = (item?.product_variation?.media?.[0]?.image?.image || "").replace(
                /\/media\/(marketplace\/)?/g, ""
              );
  
              return (
                <div key={key} className="cart-item" style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                  padding: "1rem",
                  gap: "1rem",
                  flexWrap: "wrap",
                  border: "1px solid #e0e0e0",
                }}>
                  <input
                    type="checkbox"
                    checked={!!checkedItems[item.id]}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                  <img
                    src={imageURL}
                    alt="product"
                    style={{
                      height: 80,
                      width: 80,
                      objectFit: "cover",
                      borderRadius: "10px",
                      border: "1px solid #e0e0e0",
                    }}
                  />
  
                  <div className="item-details" style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    minWidth: 200,
                    color: "#333",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}>
                    <div><span style={{ color: "#777" }}>Name:</span> {item?.product_variation?.product?.name}</div>
                    <div><span style={{ color: "#777" }}>Brand:</span> {item?.product_variation?.product?.brand?.name}</div>
                    <div><span style={{ color: "#777" }}>Size:</span> {item?.product_variation?.variation_name?.value}</div>
                    <div><span style={{ color: "#777" }}>Price:</span> <span className="item-price" style={{ color: "#28a745" }}>
                      ₹{item?.product_variation?.stock?.selling_price * item.quantity}
                    </span></div>
                  </div>
  
                  <div className="quantity-controls" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <button
                      onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                      disabled={item.quantity <= 1}
                      style={{
                        padding: "0.3rem 0.7rem",
                        fontSize: "1rem",
                        cursor: "pointer",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        backgroundColor: "#ffffff",
                      }}>−</button>
                    <span style={{ minWidth: 20, textAlign: "center" }}>{item.quantity}</span>
                    <button
                      onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                      disabled={item.quantity >= 5}
                      style={{
                        padding: "0.3rem 0.7rem",
                        fontSize: "1rem",
                        cursor: "pointer",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        backgroundColor: "#ffffff",
                      }}>+</button>
                  </div>
  
                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{ background: "none", border: "none", cursor: "pointer" }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red">
                      <path d="M3 6h18v2H3V6zm2 3h14l-1.5 13h-11L5 9zm5 2v8h2v-8H10zm4 0v8h2v-8h-2z" />
                    </svg>
                  </button>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
  


  const Action = ({ title = "button", action, disable }) => (
    <button
      disabled={disable}
      style={{
        ...MediumButtonStyle,
        border: "none",
        fontSize: 20,
        margin: 10,
        padding: 5,
        cursor: disable ? "not-allowed" : "pointer",
      }}
      onClick={action}
    >
      {title}
    </button>
  );

  const SummaryText = ({ title, value, style }) => (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      margin: "4px 0",
    }}>
      <span style={{ fontSize: 14, ...style }}>{title}</span>
      <span style={{ fontSize: 14, ...style }}>{value}</span>
    </div>
  );

  const OrderSummary = () => (
    <div
      className="order-summary-responsive"
      style={{
        width: 350,
        minWidth: 280,
        height: 350,
        padding: 20,
        backgroundColor: "#fff",
        borderRadius: 16,
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
        marginTop: 65,
        gap: "0.5rem",
        border: "1px solid #eee",
      }}
    >
      <h4 style={{ margin: "0 0 0.5rem 0", fontSize: "20px", fontWeight: "bold" }}>
        Order Summary
      </h4>
      <SummaryText title={"Item(s)"} value={checkedCart?.length || 0} />
      <SummaryText title={"MRP ₹"} value={mrp || 0} />
      <SummaryText
        title={"Discount ₹"}
        value={discountAmount || 0}
        style={{ color: "green" }}
      />
      <hr style={{ margin: "6px 0" }} />
      <SummaryText title={"Total Amount ₹"} value={totalSellingAmount || 0} />
      <div style={{ marginTop: "0.5rem", display: "flex", justifyContent: "center" }}>
        <Action
          title={"Proceed To Checkout"}
          action={() => proceedToCheckout(checkedCart)}
          disable={checkedCart?.length === 0}
        />
      </div>
    </div>
  );
  

  const UAP = () => (
    <div className="uap-box" style={{
      display: "flex",
      justifyContent: "space-evenly",
      flexWrap: "wrap",
      gap: "1rem",
      margin: 10,
      padding: 10,
      background: "rgba(244, 246, 251, 1)",
      borderRadius: 10,
    }}>
      {uap_images.map((data, key) => (
        <div key={key} style={{
          display: "flex",
          flexDirection: "column",
          background: "#fff",
          padding: 30,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 10,
        }}>
          <img src={data.icon} style={{ width: 120 }} alt={data.title} />
          <span style={{ fontSize: 18 }}>{data.title}</span>
        </div>
      ))}
    </div>
  );
  return (
    <div className="cart" style={{ display: "flex", flexDirection: "column", gap: "0.5rem", padding: "1rem" }}>
      {/* Cart content and summary */}
      <div style={{
        display: "flex",
        gap: "2rem",
        flexWrap: "wrap",
        justifyContent: "center",
      }}>
        <CartTable />
        <OrderSummary />
      </div>
      
      {/* User Assistance Panel */}
      <div>
        <UAP />
      </div>
    </div>
  );
  
  
};
